// Reusable modal. Uses the existing .vava-modal-* classes from styles.css so
// it matches OwnersEditModal / NewTaskModal visually. Esc closes; backdrop
// click closes; clicks inside don't propagate.

import { useEffect } from 'react';

export const Modal = ({ title, onClose, children, footer, width }) => {
  // Esc-to-close. Stop listening on unmount so stacked modals don't get
  // their close triggered by the wrong key event.
  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="vava-modal-backdrop" onClick={onClose}>
      <div className="vava-modal"
           onClick={(e) => e.stopPropagation()}
           style={width ? { maxWidth: width } : undefined}>
        <div className="vava-modal-head">
          <h2>{title}</h2>
          <button className="vava-modal-close" onClick={onClose} aria-label="关闭">×</button>
        </div>
        <div className="vava-modal-body">{children}</div>
        {footer && <div className="vava-modal-foot">{footer}</div>}
      </div>
    </div>
  );
};
